export default {
  name: 'Article list section - 2',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"},{"article-title":"Article 2","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"},{"article-title":"Article 3","article-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","article-image":"","button-text":"","button-link":"","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '0',
    'padding-top': '60px',
    'padding-bottom': '60px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit',
    'article-title-color': 'inherit',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'center',
    'article-columns': '1',
    'content-box': '1',
    'content-box-wrap': 'item',
    'content-box-color': 'black',
    'content-box-padding': '10px',
    'content-box-opacity': '0',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
